import styled from 'styled-components'
import img from '../../assets/images/background.svg'

export const Container = styled.div<{ visibility?: boolean }>`
  display: ${visibility => (visibility ? 'flex' : 'none')};
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  border-radius: 20px;
  margin-left: 10px;
  background-image: url(${img});
`
export const TitleBlock = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
  width: 304px;
`
export const Title = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  width: 234px;
  padding-left: 10px;
`
export const Text = styled.p`
  color: #fafafa;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  // padding-right: 10px;
  // padding-bottom: 10px;
  line-height: 21px;
  letter-spacing: 0.14px;
  width: 285px;
  // position: relative;
`
